import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Es seguro si tengo presión alta?',
    a: 'El protocolo es natural, pero siempre recomendamos consultar a tu médico antes de iniciar cualquier cambio en tu estilo de vida.'
  }, {
    q: '¿Tengo que dejar de comer lo que me gusta?',
    a: 'Aprenderás a comer estratégicamente, no a pasar hambre. El objetivo es optimizar tus hormonas usando los alimentos a tu favor.'
  }, {
    q: '¿Cuánto tiempo al día requiere?',
    a: 'Menos de 20 minutos incluyendo la lectura y los ejercicios físicos. Está diseñado para hombres ocupados.'
  }, {
    q: '¿Los resultados son permanentes?',
    a: "Si mantienes los principios básicos del 'Blindaje' que aprenderás en la fase 3, sí. Estarás reprogramando tus hábitos desde la raíz."
  }];
  return <section className="py-24 px-4 bg-[#111827] relative border-t border-white/5" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white uppercase tracking-tight mb-12" data-id="element-4">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-5">
            {faqs.map((faq, idx) => {
            const isOpen = openIndex === idx;
            return <div key={idx} className={`bg-[#1a1f2e] rounded-xl border transition-colors duration-300 ${isOpen ? 'border-[#00d4ff]/50' : 'border-white/5'}`} data-id="element-6">
                  <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-7">
                    <span className={`text-lg font-bold pr-4 transition-colors ${isOpen ? 'text-[#00d4ff]' : 'text-white'}`} data-id="element-8">
                      {faq.q}
                    </span>
                    <motion.div animate={{
                  rotate: isOpen ? 180 : 0
                }} transition={{
                  duration: 0.3
                }} className={`shrink-0 ${isOpen ? 'text-[#00d4ff]' : 'text-slate-500'}`} data-id="element-9">
                      <ChevronDown className="w-6 h-6" data-id="element-10" />
                    </motion.div>
                  </button>

                  <AnimatePresence initial={false} data-id="element-11">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} className="overflow-hidden" data-id="element-12">
                        <div className="p-6 pt-0 text-slate-300 leading-relaxed border-t border-white/5" data-id="element-13">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}